'use client';

import Link from 'next/link';
import { cn } from 'common/utils';
import ContentLoader from 'react-content-loader';
import { UserTopicTypeWithPostCount } from 'service/user';

// Skeleton loading component for topic pills
const TopicSkeletonItem = () => (
  <div className="flex gap-2">
    {Array.from({ length: 5 }, (_, index) => (
      <ContentLoader
        key={index}
        speed={1.5}
        width={100}
        height={32}
        uniqueKey={`topic-pill-skeleton-${index}`}
        viewBox={`0 0 100 32`}
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        className="rounded-full"
      >
        <rect x="0" y="0" rx="16" ry="16" width="100%" height="32" />
      </ContentLoader>
    ))}
  </div>
);

const TopicWidget = ({
  topics,
  isFetched,
  className,
  title = '関連トピック',
}: {
  topics: UserTopicTypeWithPostCount[];
  isFetched: boolean;
  className?: string;
  title?: string;
}) => {
  if (isFetched && topics?.length === 0) return null;

  return (
    <div
      className={cn('all-font-sans -mx-3 mb-4 bg-white p-3 md:mx-0', className)}
    >
      {/* Widget Header */}
      <h3 className="mb-4 text-sm font-semibold leading-none text-pp-text-primary">
        {title}
      </h3>

      {/* Topics Pills */}
      <div className="flex gap-2 overflow-x-auto">
        {!isFetched ? (
          // Show skeleton loading when data is not fetched yet
          <TopicSkeletonItem />
        ) : (
          // Show actual topics as pills
          topics.map((topic, index) => (
            <Link
              key={`${topic.id}-${index}`}
              href={`/p/post-topic/${encodeURIComponent(topic.name)}`}
              className="min-w-[100px] max-w-[180px] shrink-0 cursor-pointer truncate rounded-full bg-gray-100 px-4 py-2 text-center text-sm font-medium text-pp-text-primary transition-all hover:bg-gray-200"
            >
              {topic.name}
            </Link>
          ))
        )}
      </div>
    </div>
  );
};

export default TopicWidget;
